import { isDefined } from "@clipboard-health/util-ts";
import { isEmpty } from "lodash";

import { type WorkerCredentialsAttributes } from "./api/schema";

export function areCredentialsMissing(params: {
  isChartingAndTimeClock: boolean;
  isChartingOnly: boolean;
  isTimeClockOnly: boolean;
  credentials: WorkerCredentialsAttributes | undefined;
}) {
  const { isChartingAndTimeClock, isChartingOnly, isTimeClockOnly, credentials } = params;
  const isCharting = isChartingAndTimeClock || isChartingOnly;
  const isTimeClock = isChartingAndTimeClock || isTimeClockOnly;
  if (!isDefined(credentials)) {
    return isCharting || isTimeClock;
  }

  const { chartingCredentials, timeclockCredentials } = credentials;
  const missingChartingCredentials =
    isEmpty(chartingCredentials?.username) || isEmpty(chartingCredentials?.password);
  const missingTimeclockCredentials = isEmpty(timeclockCredentials?.pin);
  return (missingChartingCredentials && isCharting) || (missingTimeclockCredentials && isTimeClock);
}
